import React from "react";

const Icons = {
  Lock: "lock",
  Home: "home",
  Review: "reviews",
  Link: "task_alt",
  RemoveRedEye: "visibility",
  Edit: "edit",
  Badge: "badge",
  Share: "share",
  Safety_Check: "safety_check",
  List_Alt_Check: "list_alt_check",
  List: "list",
  Receipt: "receipt",
};

export default Icons;
